import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const BusquedaFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='BUSQUEDA' htmlFor='text-busqueda' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='busqueda'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='text-busqueda'
              fIsSubmitting={fIsSubmitting}
              iError={iError}
              iTouched={iTouched}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(BusquedaFormGroup)
